'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'peach';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e20b';
var svgPathData = 'M96 0L80 0l0 16 0 16c0 22.3 5.7 43.2 15.7 61.5c10.2-3.9 20.8-7.1 31.7-9.3C117.6 69.1 112 51.2 112 32l32 0c39.8 0 73.9 24.2 88.5 58.6c8.1 2.8 16 6 23.5 9.7c7.6-3.7 15.5-7 23.5-9.7C294.1 56.2 328.2 32 368 32l32 0c0 19.2-5.6 37.1-15.4 52.1c10.9 2.3 21.5 5.4 31.7 9.3C426.3 75.2 432 54.3 432 32l0-16 0-16L416 0 368 0c-48.2 0-90.2 26.6-112 66C234.2 26.6 192.2 0 144 0L96 0zM336 280c0-48-20.1-91.3-52.4-121.9c18.2-9 38.7-14.1 60.4-14.1c75.1 0 136 60.9 136 136c0 57.4-49.4 107.1-112.7 145.7c-30.1 18.4-60.5 32.4-83.5 41.9c-11.4 4.7-21 8.2-27.5 10.6l-.3 .1-.3-.1c-6.6-2.3-16.1-5.9-27.5-10.6c-23-9.5-53.4-23.5-83.5-41.9C81.4 387.1 32 337.4 32 280c0-75.1 60.9-136 136-136s136 60.9 136 136l32 0zM256 136.9c-25.6-15.8-55.7-24.9-88-24.9C75.2 112 0 187.2 0 280C0 432 256 512 256 512s256-80 256-232c0-92.8-75.2-168-168-168c-32.3 0-62.4 9.1-88 24.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPeach = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;